import React from 'react';
import './textunderline.css'

function Underline() {
    return (
        <div className="main-underline">
            <div className="underline">
                <div className="underline1"></div>
                <div className="underline-slant">/</div>

                <div className="underline-slant2">/</div>
                <div className="underline2"></div>
                <span></span>
            </div>

            {/* <div className="underline">
            <div className="underli">ehjcfkdc;</div>
            </div> */}
        </div>
    )
}

export default Underline
